import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
import PrintRounded from "@mui/icons-material/PrintRounded";
import PaymentsRounded from "@mui/icons-material/PaymentsRounded";
import Inventory2Rounded from "@mui/icons-material/Inventory2Rounded";
import DownloadRounded from "@mui/icons-material/DownloadRounded";
import RefreshRounded from "@mui/icons-material/RefreshRounded";
import SearchRounded from "@mui/icons-material/SearchRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import ExpandLessRounded from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import VisibilityRounded from "@mui/icons-material/VisibilityRounded";
import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import SearchOffRounded from "@mui/icons-material/SearchOffRounded";
import CheckRounded from "@mui/icons-material/CheckRounded";
import RadioButtonUncheckedRounded from "@mui/icons-material/RadioButtonUncheckedRounded";
const icons = {
  receipt_long: ReceiptLongRounded,
  print: PrintRounded,
  payments: PaymentsRounded,
  inventory_2: Inventory2Rounded,
  download: DownloadRounded,
  refresh: RefreshRounded,
  search: SearchRounded,
  tune: TuneRounded,
  expand_less: ExpandLessRounded,
  expand_more: ExpandMoreRounded,
  arrow_forward: ArrowForwardRounded,
  visibility: VisibilityRounded,
  content_copy: ContentCopyRounded,
  open_in_new: OpenInNewRounded,
  search_off: SearchOffRounded,
  check: CheckRounded,
  radio_button_unchecked: RadioButtonUncheckedRounded,
};
export default function ProductionIcon({ children, ...props }) {
  const Component = icons[children] || ReceiptLongRounded;
  return <Component {...props} />;
}
